import { FC, ReactNode } from "react"
import {
  Control,
  Controller,
  FieldErrors,
  RegisterOptions,
} from "react-hook-form"
import { useTranslation } from "react-i18next"
import { SxProps } from "@mui/system"

import { USelect } from "../index"
import { FormControl, FormHelperText, InputLabel } from "../mui.components"

interface items {
  key: string
  value: string
}
interface IFormSelect {
  inputLabel: string
  helperText?: string | null
  fieldName: string
  rules: RegisterOptions
  errors: FieldErrors
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: any
  formSxprops?: SxProps
  options: ReactNode | items[]
  selectedValue: string
}

const FormSelect: FC<IFormSelect> = ({
  fieldName,
  inputLabel,
  rules,
  errors,
  control,
  helperText = null,
  formSxprops = { my: 2 },
  options,
  selectedValue,
}) => {
  const { t } = useTranslation("common")
  const hasError = !!(errors && errors[fieldName])
  const errorMsg = errors[fieldName]?.message?.toString()
  return (
    <FormControl
      fullWidth
      size={"medium"}
      sx={{ ...formSxprops }}
      error={hasError}
    >
      <InputLabel id={fieldName}>{t(inputLabel)}</InputLabel>
      <Controller
        control={control}
        name={fieldName}
        rules={rules}
        render={({ field: { onChange, name, value } }) => (
          <USelect
            label={t(inputLabel)}
            onChangeHandler={(e): void => {
              onChange(e)
            }}
            id={`select-${fieldName}`}
            labelId={name}
            options={options}
            defaultValue={value}
          />
        )}
      />
      {helperText && (
        <FormHelperText id={`${fieldName}-helper-text`}>
          {t(helperText)}
        </FormHelperText>
      )}
      {hasError && errorMsg && (
        <FormHelperText id={`${fieldName}-error`}>{t(errorMsg)}</FormHelperText>
      )}
    </FormControl>
  )
}

export default FormSelect
